import { configureStore } from '@reduxjs/toolkit'
import sessionSlice from './reducers/sessionSlice';
import contractsSlice from './reducers/contractsSlice';
import requestsSlice from './reducers/requestsSlice';
import usersSlice from './reducers/usersSlice';

const store = configureStore({
  reducer: {
    session: sessionSlice,
    contracts: contractsSlice,
    requests: requestsSlice,
    users: usersSlice,
  }
})

export default store;